var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
export var HARVEST_ERROR_CODES = [
    "RUN_WENT_SILENT",
    "INTERRUPTED_BY_RESTART",
    "STOPPED_BY_USER",
    "NOT_HANDED_TO_THREAD",
    "OAI_FETCH_DEADLINE",
    "HARVEST_ERROR",
    "QUEUE_CANCELLED_JOB_DISABLED",
    "QUEUE_CANCELLED_LIBRARY_NOT_HARVESTABLE",
];
var HarvestAlreadyRunningError = /** @class */ (function (_super) {
    __extends(HarvestAlreadyRunningError, _super);
    function HarvestAlreadyRunningError() {
        return _super.call(this, "Harvest already running") || this;
    }
    return HarvestAlreadyRunningError;
}(Error));
export { HarvestAlreadyRunningError };
